var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgModalBlockErrorArrow = function SvgModalBlockErrorArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 115
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Kassy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Allow-Window-2",
    transform: "translate(-1280 -16)",
    stroke: "#FFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(1281 18)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 2c5.333 45.852-4.333 82.518-29 110",
    id: "Path-5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    d: "M23 13.478L29 .579 36.007 12"
  }))))));
};
export default SvgModalBlockErrorArrow;